import styled from 'styled-components';

export const PubblicoImpiegoFormFlowStyles = styled.div``;

export const PubblicoImpiegoFormStyles = styled.form`
  width: 50%;
  margin: 0 auto;

 
    @media (min-width: 300px) and (max-width: 1000px) {
      width: 100%;
      margin: 0;
  }
  @media (min-width: 1001px) and (max-width: 1300px) {
      width: 80%;
  }`;
